export const composite = value => (...fn) => fn.reduce((previusFn, fn) => fn(previusFn), value)


// WEBPACK FOOTER //
// ./src/Utils/Composite.js